import { IApprovalItemRow } from "../../../models/Approval";

export const actionTypes = {
  FETCH_APPROVALS_REQUEST: "FETCH_APPROVALS_REQUEST",
  FETCH_APPROVALS_SUCCESS: "FETCH_APPROVALS_SUCCESS",
  FETCH_APPROVALS_FAILURE: "FETCH_APPROVALS_FAILURE",
  FETCH_PAGINATION_APPROVALS_REQUEST: "FETCH_PAGINATION_APPROVALS_REQUEST",
  FETCH_PAGINATION_APPROVALS_SUCCESS: "FETCH_PAGINATION_APPROVALS_SUCCESS",
  FETCH_PAGINATION_APPROVALS_FAILURE: "FETCH_PAGINATION_APPROVALS_FAILURE",
  FETCH_CSV_APPROVALS_REQUEST: "FETCH_CSV_APPROVALS_REQUEST",
  FETCH_CSV_APPROVALS_SUCCESS: "FETCH_CSV_APPROVALS_SUCCESS",
  FETCH_CSV_APPROVALS_FAILURE: "FETCH_CSV_APPROVALS_FAILURE",
  SELECT_APPROVAL: "SELECT_APPROVAL",
  FETCH_APPROVAL_DETAIL: "FETCH_APPROVAL_DETAIL",
  FETCH_APPROVAL_DETAIL_SUCCESS: "FETCH_APPROVAL_DETAIL_SUCCESS",
  FETCH_APPROVAL_DETAIL_FAILURE: "FETCH_APPROVAL_DETAIL_FAILURE",
  APPROVE_APPROVAL_REQUEST: "APPROVE_APPROVAL_REQUEST",
  APPROVE_APPROVAL_REQUEST_SUCCESS: "APPROVE_APPROVAL_REQUEST_SUCCESS",
  APPROVE_APPROVAL_REQUEST_FAIILURE: "APPROVE_APPROVAL_REQUEST_FAIILURE",
  REJECT_APPROVALS_REQUEST: "REJECT_APPROVALS_REQUEST",
  REJECT_APPROVALS_REQUEST_SUCCESS: "REJECT_APPROVALS_REQUEST_SUCCESS",
  REJECT_APPROVALS_REQUEST_FAILURE: "REJECT_APPROVALS_REQUEST_FAILURE",
  SELECT_TAB: "SELECT_TAB",

  RESET_APPROVAL_DETAIL: "RESET_APPROVAL_DETAIL",
  DELETE_ATTACHMENT_APPROVALS: "DELETE_ATTACHMENTS_APPROVALS",
  DELETE_ATTACHMENT_APPROVALS_SUCCESS: "DELETE_ATTACHMENTS_APPROVALS_SUCCESS",
  DELETE_ATTACHMENT_APPROVALS_FAILURE: "DELETE_ATTACHMENTS_APPROVALS_FAILURE",
  SAVE_ATTACHMENTS_APPROVALS: "SAVE_ATTACHMENTS_APPROVALS",
  SAVE_ATTACHMENTS_APPROVALS_SUCCESS: "SAVE_ATTACHMENTS_APPROVALS_SUCCESS",
  SAVE_ATTACHMENTS_APPROVALS_FAILURE: "SAVE_ATTACHMENTS_APPROVALS_FAILURE",
};

export const fetchApproval = () => {
  return {
    type: actionTypes.FETCH_APPROVALS_REQUEST,
  };
};

export const fetchApprovalFailure = (payload: IApprovalItemRow[]) => {
  return {
    type: actionTypes.FETCH_APPROVALS_FAILURE,
    payload,
  };
};

export const fetchApprovalSuccess = (payload: IApprovalItemRow[]) => {
  return {
    type: actionTypes.FETCH_APPROVALS_SUCCESS,
    payload,
  };
};

export const fetchPaginationApprovals = (payload: any) => {
  return {
    type: actionTypes.FETCH_PAGINATION_APPROVALS_REQUEST,
    payload,
  };
};

export const fetchPaginationApprovalsFailure = (
  payload: IApprovalItemRow[]
) => {
  return {
    type: actionTypes.FETCH_PAGINATION_APPROVALS_FAILURE,
    payload,
  };
};

export const fetchPaginationApprovalsSuccess = (
  payload: IApprovalItemRow[]
) => {
  return {
    type: actionTypes.FETCH_PAGINATION_APPROVALS_SUCCESS,
    payload,
  };
};

export const fetchCSVApprovals = (payload: any) => {
  return {
    type: actionTypes.FETCH_CSV_APPROVALS_REQUEST,
    payload,
  };
};

export const fetchCSVApprovalsFailure = (payload: IApprovalItemRow[]) => {
  return {
    type: actionTypes.FETCH_CSV_APPROVALS_FAILURE,
    payload,
  };
};

export const fetchCSVApprovalsSuccess = (payload: IApprovalItemRow[]) => {
  return {
    type: actionTypes.FETCH_CSV_APPROVALS_SUCCESS,
    payload,
  };
};

export const selectApprovalRequest = (payload: any) => {
  return {
    type: actionTypes.SELECT_APPROVAL,
    payload,
  };
};

export const approveApprovalRequest = (payload: any) => {
  return {
    type: actionTypes.APPROVE_APPROVAL_REQUEST,
    payload,
  };
};

export const approveApprovalRequestSuccess = (payload: any) => {
  return {
    type: actionTypes.APPROVE_APPROVAL_REQUEST_SUCCESS,
    payload,
  };
};

export const approveApprovalRequestFailure = (error: any) => {
  return {
    type: actionTypes.APPROVE_APPROVAL_REQUEST_FAIILURE,
    error,
  };
};

export const rejectApprovalRequest = (payload: any) => {
  return {
    type: actionTypes.REJECT_APPROVALS_REQUEST,
    payload,
  };
};

export const rejectApprovalRequestSuccess = (payload: any) => {
  return {
    type: actionTypes.REJECT_APPROVALS_REQUEST_SUCCESS,
    payload,
  };
};

export const rejectApprovalRequestFailure = (error: any) => {
  return {
    type: actionTypes.REJECT_APPROVALS_REQUEST_FAILURE,
    error,
  };
};

export const fetchApprovalDetail = (id: string) => {
  return {
    type: actionTypes.FETCH_APPROVAL_DETAIL,
    id,
  };
};

export const fetchApprovalDetailSuccess = (payload: any) => {
  return {
    type: actionTypes.FETCH_APPROVAL_DETAIL_SUCCESS,
    payload,
  };
};

export const fetchApprovalDetailFailure = (error: any) => {
  return {
    type: actionTypes.FETCH_APPROVAL_DETAIL_FAILURE,
    error,
  };
};

export const resetApprovalDetail = () => {
  return {
    type: actionTypes.RESET_APPROVAL_DETAIL,
  };
};

export const selectTab = (payload: any) => {
  return {
    type: actionTypes.SELECT_TAB,
    payload,
  };
};

export const deleteAttachmentApprovals = (id: string) => ({
  type: actionTypes.DELETE_ATTACHMENT_APPROVALS,
  id,
});

export const deleteAttachmentApprovalsSuccess = (payload: any) => ({
  type: actionTypes.DELETE_ATTACHMENT_APPROVALS_SUCCESS,
  payload,
});

export const deleteAttachmentApprovalsFailure = (error: any) => ({
  type: actionTypes.DELETE_ATTACHMENT_APPROVALS_FAILURE,
  error,
});

export const saveAttachmentsApprovals = (id: string, files: any) => ({
  type: actionTypes.SAVE_ATTACHMENTS_APPROVALS,
  id,
  files,
});

export const saveAttachmentsApprovalsSuccess = (payload: any) => ({
  type: actionTypes.SAVE_ATTACHMENTS_APPROVALS_SUCCESS,
  payload,
});

export const saveAttachmentsApprovalsFailure = (error: any) => ({
  type: actionTypes.SAVE_ATTACHMENTS_APPROVALS_FAILURE,
  error,
});
